/* eslint semi:0 */
import { noop, } from '../../jsCore/utils/fn'
import { warn, } from '../../jsCore/application/console'
import { getIsMobileOrTablet, } from '../../jsCore/utils/ua'
import { addDocumentEvent, node, } from '../../jsCore/utils/dom'
import { SELECTORS, } from '../../jsCore/config/preRenderedSelectorsConfig'
import { getPageType, isSupportedForDomain, } from '../../jsCore/application/pageDataObject'


const EDITION_SELECTION_FEATURE_ID = 'EditionSelection'
const { EDITION_DROPDOWN, EDITION_COMPONENT, SITE_HEADER, } = SELECTORS
const PAGE_TYPES_TO_ADD_CLICK_LISTENERS = ['homepage', ]

function registerEditionSelection(){
  if (!PAGE_TYPES_TO_ADD_CLICK_LISTENERS.includes(getPageType())) {
    return null
  }
  const editionCheckbox = node(EDITION_DROPDOWN)
  if (!editionCheckbox) {
    return warn('Cannot find edition checkbox', { editionCheckbox, pageType: getPageType(), })
  }
  if (!getIsMobileOrTablet()) {
    // do not allow desktop users to toggle the checkbox,
    // see https://90min-confluence.atlassian.net/browse/FEATURES-3399
    editionCheckbox.disabled = true
    return editionCheckbox
  }
  const editionComponent = node(EDITION_COMPONENT)
  const siteHeader = node(SITE_HEADER)
  if (!editionComponent || !siteHeader) {
    return warn('cannot find edition component or site header component')
  }
  // the following line is a weird fix for a bug:
  // try removing this line, and using an iphone try expanding the lang dropdown
  // then, try clicking on the black area inside the site header.
  // without this line, it will not close the dropdown on ALL ios devices
  siteHeader.addEventListener('click', noop)

  addDocumentEvent('click', function documentClickEditionHandler(e){
    if (editionCheckbox.checked) {
      e.preventDefault()
    }
    editionCheckbox.checked = false
  })
  editionComponent.addEventListener('click', function editionComponentClickHandler(e){
    e.stopPropagation()
  })
  return editionCheckbox
}

export default function initializeEditionSelection(){
  const shouldInitializeEditionSelection = isSupportedForDomain(EDITION_SELECTION_FEATURE_ID)
  if (shouldInitializeEditionSelection) {
    registerEditionSelection()
  }
  return shouldInitializeEditionSelection
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/edition_dropdown/editionDropdown.js